import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CerSessionService } from 'src/cer/cer-session/cer-session.service';
import { CerAuthorizeService } from '../cer-authorize.service';

@Component({
  selector: 'cer-login',
  template: '<h3>Login</h3>'
})
export class CerLoginComponent {

  constructor(private authService: CerAuthorizeService,
    private sessionService: CerSessionService,
    private activatedRoute: ActivatedRoute) { 
      this.sessionService.relogin('/');
    }

}
